import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class MetricsEditRoute extends Route {
	@service('model-manager/custom-queries')
	declare mmCustomQueriesService: Service.ModelManager.CustomQueries;
	@service('model-manager/scripts') declare mmScriptsService: Service.ModelManager.Scripts;
	@service('model-manager/horizon-metrics')
	declare mmHorizonMetricsService: Service.ModelManager.HorizonMetrics;

	// The edit routes look their custom metric up in the store, so it must be loaded before they run.
	override beforeModel(): Promise<unknown> {
		return Promise.all([
			this.mmCustomQueriesService.requestCustomQueries(),
			this.mmScriptsService.requestScripts(),
			this.mmHorizonMetricsService.requestHorizonMetrics(),
		]);
	}
}
